import { PlusIcon, Trash2Icon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

import { ProfileTableProps } from "../../types/profileTable";
import NumericInput from "./NumericInput";

const ProfileTable = (props: ProfileTableProps) => {
  const { profiles, onUpdate, onDelete, onAdd } = props;
  return (
    <div className="space-y-3">
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr>
              {[
                "Name",
                "Q1 days",
                "Q1 ×",
                "Q2 days",
                "Q2 ×",
                "Q3 days",
                "Q3 ×",
                "Cutoff days",
                "",
              ].map((h) => (
                <th
                  key={h}
                  className="text-center px-2 py-2 text-xs font-semibold text-foreground whitespace-nowrap first:text-left"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {profiles.map((p) => (
              <tr key={p.id} className="border-t border-border">
                <td className="px-2 py-1.5">
                  <Input
                    value={p.name}
                    onChange={(e) => onUpdate(p.id, { name: e.target.value })}
                    className="h-7 text-sm bg-background min-w-24"
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <NumericInput
                    value={p.q1_days}
                    onChange={(v) => onUpdate(p.id, { q1_days: v })}
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <NumericInput
                    value={p.q1_multiplier}
                    step={0.05}
                    min={0}
                    max={1}
                    onChange={(v) => onUpdate(p.id, { q1_multiplier: v })}
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <NumericInput
                    value={p.q2_days}
                    onChange={(v) => onUpdate(p.id, { q2_days: v })}
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <NumericInput
                    value={p.q2_multiplier}
                    step={0.05}
                    min={0}
                    max={1}
                    onChange={(v) => onUpdate(p.id, { q2_multiplier: v })}
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <NumericInput
                    value={p.q3_days}
                    onChange={(v) => onUpdate(p.id, { q3_days: v })}
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <NumericInput
                    value={p.q3_multiplier}
                    step={0.05}
                    min={0}
                    max={1}
                    onChange={(v) => onUpdate(p.id, { q3_multiplier: v })}
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <NumericInput
                    value={p.limit_days}
                    onChange={(v) => onUpdate(p.id, { limit_days: v })}
                  />
                </td>
                <td className="px-2 py-1.5 text-center">
                  <button
                    onClick={() => onDelete(p.id)}
                    disabled={profiles.length <= 1}
                    className="text-muted-foreground hover:text-destructive transition-colors disabled:opacity-30 disabled:pointer-events-none"
                    aria-label="Delete profile"
                  >
                    <Trash2Icon className="h-4 w-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-muted-foreground">
        Age ≤ Q1 days → Q1 multiplier · Q1 &lt; age ≤ Q2 → Q2 multiplier · Q2
        &lt; age ≤ Q3 → Q3 multiplier · age &gt; Cutoff → excluded (multiplier =
        0).
      </p>
      <Button variant="outline" size="sm" onClick={onAdd}>
        <PlusIcon className="mr-1.5 h-3.5 w-3.5" />
        Add profile
      </Button>
    </div>
  );
};

export default ProfileTable;
